let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4Vi6")).then(() => parcelRequire('gvSye'));